












































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import Loader from "@/modules/externals/components/Loader.vue";
import Paginate from "vuejs-paginate";
import {
  BusinessList,
  FetchPaginatedBusinessesPayload,
} from "@/modules/businesses/types";
import EmptyTable from "@/modules/applicants/components/EmptyTable.vue";
import { Status } from "@/modules/businesses/types/index";
import TableLoader from "@/modules/externals/components/TableLoader.vue";
import TableHeader from "@/modules/externals/components/TableHeader.vue";
import { FetchPayload } from "@/modules/businesses/types/index";

const Businesses = namespace("business");

// eslint-disable-next-line @typescript-eslint/no-var-requires
const utc = require("dayjs/plugin/utc");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  components: {
    loader: Loader,
    paginate: Paginate,
    "empty-table": EmptyTable,
    "table-loader": TableLoader,
    "table-header": TableHeader,
  },
})
export default class AllBusinessesTable extends Vue {
  @Businesses.Getter("getAllBusinesses") allBusinesses: BusinessList;
  @Businesses.Getter("isAllBusinessesEmpty") isAllBusinessesEmpty: boolean;
  @Businesses.Action("fetchPaginatedBusinesses")
  fetchPaginatedBusinesses!: (
    payload: FetchPaginatedBusinessesPayload
  ) => Promise<{}>;
  @Businesses.Getter("getIsFetchingBusinesses") isFetchingBusinesses: boolean;
  @Businesses.Action("fetchBusinesses") fetchBusinesses!: (
    payload?: FetchPayload
  ) => Promise<{}>;
  @Prop() readonly setSortBy!: () => void;
  @Prop() readonly setSortOrder!: () => void;
  @Prop() readonly sort!: () => void;
  @Prop() readonly sortOrder!: string;
  @Prop() readonly sortBy!: string;

  loading = false;
  isPending: Status = Status.PENDING;
  isApproved: Status = Status.APPROVED;
  isRejected: Status = Status.REJECTED;

  localDate(date: string) {
    return dayjs(date).format("MMM D YYYY");
  }
  localTime(date: string) {
    return dayjs(date).subtract(5, "hour").format("h:mm a");
  }

  async changePage(pageNumber: number) {
    this.loading = true;
    await this.fetchPaginatedBusinesses({
      pageNumber,
      status: "all",
    });
    this.loading = false;
  }
}
